import axios from "axios";

export const getGroupServers = (headers) => {
    return axios.get(`${process.env.REACT_APP_DDDT_APP}/nidJob/getGroupServer`, {
        headers,
    });
};

export const getListServers = (headers, factoryName) => {
    return axios.get(`${process.env.REACT_APP_DDDT_APP}/nidJob/getDanhSachServer?factoryName=${factoryName}`, {
        headers,
    });
};

export const getActionJobs = (headers, { ipServer, factoryName }) => {
    return axios.get(`${process.env.REACT_APP_DDDT_APP}/nidJob/getServerStatus?factoryName=${factoryName}&ipServer=${ipServer}`, { headers });
};

export const callActionJob = (headers, body) => {
    return axios.post(`${process.env.REACT_APP_DDDT_APP}/nidJob/actionJob`, body, { headers });
};
